import { render, staticRenderFns } from "./cargoDocExtend.vue?vue&type=template&id=23e10520&scoped=true&"
import script from "./cargoDocExtend.vue?vue&type=script&lang=js&"
export * from "./cargoDocExtend.vue?vue&type=script&lang=js&"
import style0 from "./cargoDocExtend.vue?vue&type=style&index=0&id=23e10520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e10520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e10520')) {
      api.createRecord('23e10520', component.options)
    } else {
      api.reload('23e10520', component.options)
    }
    module.hot.accept("./cargoDocExtend.vue?vue&type=template&id=23e10520&scoped=true&", function () {
      api.rerender('23e10520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/cargoDocExtend.vue"
export default component.exports